import React from "react";
import { Trans } from "react-i18next";

import "./index.less";

const ErrorMessage = ({
  className = "",
  type,
  title = "",
  description = "",
  onDismiss,
  isDismissable,
  dismissIconClass = "icon-close"
}) => {
  return (
    <div className={`fetch-error-banner ${className}`}>
      <div className={`error-callout-container bs-callout ${type}`}>
        <div className="error-title">
          <Trans>{title}</Trans>
        </div>
        <div className="error-description">
          <Trans>{description}</Trans>
        </div>
      </div>
      {isDismissable && (
        <span className={`close-icon icon ${dismissIconClass}`} onClick={onDismiss} />
      )}
    </div>
  );
};

ErrorMessage.defaultProps = {
  type: "error",
  isDismissable: false,
};

export default ErrorMessage;
